import Vue from 'vue'
/**
 * 路由跳转
 * @param [string] 路由
 * @return [null]
 */
Vue.prototype.router = function (param) {
  this.$router.push(param, () => { })
  document.body.style.overflow = ''
}
/**
 * 打印参数
 * @param [string] 路由
 * @return [null]
 */
Vue.prototype.p = function (param) {
  console.log(param)
}
/**
 * 获取窗口屏幕高度
 * @param string 需要获取的名称
 * @return number
 */
Vue.prototype.size = function (param) {
  let res = ''
  if (param) {
    switch (param) {
      case 'innerWidth':
        res = window.innerWidth
        break
      case 'innerHeight':
        res = (window.innerHeight - 1)
        break
      case 'screenWidth':
        res = window.screen.width
        break
      case 'screenHeight':
        res = (window.screenHeight - 1)
        break
    }
  }
  return res
}
/*
* 判断是否是移动端
*/
Vue.prototype.isMobile = function (param, screenWidth) {
  if (screenWidth > 768) {
    return param
  } else {
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js